import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

import AppRadio from './AppRadio';
import {getFullPicture} from '../modules/imageHandler';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {
    border: '0.5px solid rgba(122,122,122,0.2)',
    borderRadius: 10,
  },
  card: {
    width: 30,
    height: 25,
    backgroundColor: 'pink',
  },
  button: {
    fontWeight: 400,
    marginRight: theme.spacing(2),
  },
}));

const CreditCard = ({item, handleDelete, handleChangeMain}) => {
  const classes = useStyles();

  return (
    <Box display="flex" justifyContent="space-between" className={classes.root}>
      <Box display="flex" alignItems="center">
        <AppRadio checked={item.default === 'true'} onClick={handleChangeMain} />
        <img
          width={76.8}
          height={48}
          src={getFullPicture(`logos-tarjetas-de-credito/${item.brand}.png`)}
          alt={`logos-tarjetas-de-credito/${item.brand}.png`}
        />
        <Typography>{item.masked_number}</Typography>
      </Box>
      <IconButton size="small" onClick={handleDelete} color="secondary" className={classes.button}>
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </Box>
  );
};

export default CreditCard;
